import React, { useState } from 'react';

/**
 * Password input with a show/hide toggle.
 * Spreads any extra props (id, value, onChange, autoComplete, required, minLength, …) onto the input.
 */
export default function PasswordInput({ className = 'form-control', wrapperClassName = '', ...rest }) {
  const [visible, setVisible] = useState(false);
  const label = visible ? 'Hide password' : 'Show password';

  return (
    <div className={`password-field ${wrapperClassName}`.trim()}>
      <input
        {...rest}
        type={visible ? 'text' : 'password'}
        className={`${className} password-field__input`.trim()}
      />
      <button
        type="button"
        className="password-toggle"
        onClick={() => setVisible((v) => !v)}
        aria-label={label}
        aria-pressed={visible}
        title={label}
        tabIndex={-1}
      >
        {visible ? (
          <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
            <path
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3 3l18 18M10.6 10.6a2 2 0 0 0 2.8 2.8M9.9 5.2A9.5 9.5 0 0 1 12 5c5 0 9 4.5 10 7-0.5 1.2-1.6 2.9-3.3 4.3M6.3 6.3C4.3 7.6 2.8 9.6 2 12c1 2.5 5 7 10 7 1.6 0 3.1-.4 4.4-1.1"
            />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
            <path
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7Z"
            />
            <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="1.8" />
          </svg>
        )}
      </button>
    </div>
  );
}
